// extracted by mini-css-extract-plugin
export default {"specialsContainer":"Specials_specialsContainer__aSBT9","specialsHeader":"Specials_specialsHeader__EaDiD","specialsCardsContainer":"Specials_specialsCardsContainer__emdVQ"};